import { Col, Row } from "react-bootstrap";
import { EConnectionStatus } from "../../oversight-core/enums/connection-status";
import MaterialIcon from "../../oversight-core/ui-elements/material-icon/material-icon";
import styles from "./ac-controller.module.scss";

interface IProps {
  temperature: number;
  isShowTemperatureText?: boolean;
  connectionState: EConnectionStatus;
  onIncrease: (event: React.MouseEvent<HTMLElement>) => void;
  onDecrease: (event: React.MouseEvent<HTMLElement>) => void;
}

const AcController = (props: IProps) => {
  const {
    temperature,
    isShowTemperatureText,
    connectionState,
    onIncrease,
    onDecrease,
  } = props;

  return (
    <Row
      className={`align-items-center flex-nowrap ${
        connectionState === EConnectionStatus.DISCONNECTED ? `opacity-50` : ``
      }`}
    >
      <Col className="col-auto">
        <div
          className={`${styles.remove} p-2 ${
            connectionState === EConnectionStatus.CONNECTED
              ? `cursor-pointer`
              : `cursor-disabled`
          }`}
        >
          <MaterialIcon
            icon="remove"
            color="#69768B"
            size={12}
            onClick={onDecrease}
          />
        </div>
      </Col>
      <Col className="col-auto">
        <Row className="flex-column align-items-center justify-content-center">
          <Col className="col-auto">
            <Row className="align-items-center">
              <Col className="col-auto px-0">
                <MaterialIcon
                  icon="device_thermostat"
                  color="#69768B"
                  size={12}
                />
              </Col>
              <Col className="px-0 font-weight-600 text-light col-auto">
                {temperature}
              </Col>
              <Col className="px-0 font-weight-400 text-light col-auto">
                &#8451;
              </Col>
            </Row>
          </Col>
          {isShowTemperatureText && (
            <Col className="text-light font-weight-400 font-size-14">
              Temperature
            </Col>
          )}
        </Row>
      </Col>
      <Col className="col-auto">
        <div
          className={`${styles.remove} p-2 ${
            connectionState === EConnectionStatus.CONNECTED
              ? `cursor-pointer`
              : `cursor-disabled`
          }`}
        >
          <MaterialIcon
            icon="add"
            color="#69768B"
            size={12}
            onClick={onIncrease}
          />
        </div>
      </Col>
    </Row>
  );
};

export default AcController;
